module.exports = __webpack_public_path__ + "static/media/bg-4.6902a03e.jpg";